var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdultsW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.000000 0.000000 96.000000 96.000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Icons_ManAndWoman",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 15,
    r: 7,
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    fill: "#F2F2F2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 15,
    r: 7,
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    fill: "#F2F2F2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 82.900002 52.099998 L 77.199997 31.000000 C 77.000000 30.400000 76.699997 29.799999 76.300003 29.400000 C 74.400002 27.400000 72.000000 25.900000 69.400002 25.000000 C 67.699997 24.299999 65.900002 24.000000 64.000000 24.000000 C 62.099998 24.000000 60.299999 24.299999 58.599998 24.900000 C 55.900002 25.799999 53.599998 27.299999 51.700001 29.299999 C 51.299999 29.799999 51.000000 30.299999 50.799999 30.900000 L 48.000000 41.400002 L 45.200001 31.000000 C 45.000000 30.400000 44.700001 29.799999 44.299999 29.400000 C 42.400002 27.400000 40.000000 25.900000 37.400002 25.000000 C 35.700001 24.299999 33.900002 24.000000 32.000000 24.000000 C 30.100000 24.000000 28.299999 24.299999 26.600000 24.900000 C 23.900000 25.799999 21.600000 27.299999 19.700001 29.299999 C 19.299999 29.799999 19.000000 30.299999 18.799999 30.900000 L 13.200000 52.000000 C 12.800000 53.599998 13.600000 55.400002 15.300000 55.799999 C 15.500000 56.000000 15.700000 56.000000 16.000000 56.000000 C 17.299999 56.000000 18.500000 55.099998 18.900000 53.799999 L 24.000000 34.599998 L 24.000000 57.000000 L 24.000000 88.000000 L 30.000000 88.000000 L 30.000000 57.000000 L 34.000000 57.000000 L 34.000000 88.000000 L 40.000000 88.000000 L 40.000000 57.000000 L 40.000000 34.599998 L 45.099998 53.700001 C 45.500000 55.000000 46.700001 55.900002 48.000000 55.900002 C 48.299999 55.900002 48.500000 55.900002 48.799999 55.799999 C 49.700001 55.500000 50.400002 54.799999 50.700001 54.000000 C 50.799999 54.000000 56.000000 34.599998 56.000000 34.599998 L 56.000000 42.700001 L 50.299999 64.000000 L 56.000000 64.000000 L 56.000000 88.000000 L 62.000000 88.000000 L 62.000000 64.000000 L 66.000000 64.000000 L 66.000000 88.000000 L 72.000000 88.000000 L 72.000000 64.000000 L 77.699997 64.000000 L 72.000000 42.700001 L 72.000000 34.599998 L 77.099998 53.700001 C 77.500000 55.000000 78.699997 55.900002 80.000000 55.900002 C 80.300003 55.900002 80.500000 55.900002 80.800003 55.799999 C 82.400002 55.400002 83.300003 53.700001 82.900002 52.099998 Z",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    fill: "#F2F2F2",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdultsW);
export default __webpack_public_path__ + "static/media/Adults_w.d0c4e07195e8d26c4a5914ea02d6b24a.svg";
export { ForwardRef as ReactComponent };